import { useState } from "react";
import { Trash2, AlertTriangle } from "lucide-react";
import { Button } from "./ui/button";
import api, { apiErr } from "../lib/api";
import { toast } from "sonner";

export default function DeleteRecordButton({ entity, id, label, onDeleted }) {
  const [arm, setArm] = useState(false);
  const [busy, setBusy] = useState(false);
  if (!id) return null;
  const doDelete = async () => {
    setBusy(true);
    try { await api.delete(`/${entity}/${id}`); toast.success(`${label} deleted`); onDeleted?.(); }
    catch (e) { toast.error(apiErr(e)); }
    setBusy(false);
  };
  if (!arm) return <Button type="button" variant="outline" className="border-red-200 text-red-600 hover:bg-red-50" onClick={() => setArm(true)} data-testid={`delete-${entity}-btn`}><Trash2 className="w-4 h-4 mr-1.5" />Delete</Button>;
  return (
    <div className="flex items-center gap-2 text-xs text-red-700" data-testid={`delete-${entity}-confirm`}>
      <AlertTriangle className="w-4 h-4" /><span>Delete this {label.toLowerCase()}? Notes, tasks and links stay in the audit trail.</span>
      <Button type="button" size="sm" className="bg-red-600 hover:bg-red-700 text-white" onClick={doDelete} disabled={busy} data-testid={`delete-${entity}-yes`}>{busy ? "Deleting…" : "Yes, delete"}</Button>
      <Button type="button" size="sm" variant="ghost" onClick={() => setArm(false)}>Keep</Button>
    </div>
  );
}
